export const RECORD_TYPES = {
  owner: {
    label: "Owner",
    apiPath: "owners",
    searchField: "name_formatted",
    pathPrefix: "/owners",
    pathMatcher: /^\/owners\/(\d+)/,
    renderLabel: (row) => row.name_formatted || row.name || `Owner ${row.id}`,
  },
  idi_person: {
    label: "IDI Person",
    apiPath: "idi-persons",
    searchField: "name",
    pathPrefix: "/idi-persons",
    pathMatcher: /^\/idi-persons\/(\d+)/,
    renderLabel: (row) =>
      row.name ||
      [row.first_name, row.last_name].filter(Boolean).join(" ") ||
      `IDI Person ${row.id}`,
  },
  evaluation: {
    label: "Evaluation",
    apiPath: "evaluations",
    searchField: "name",
    pathPrefix: "/evaluations",
    pathMatcher: /^\/evaluations\/(\d+)/,
    renderLabel: (row) => row.name || `Evaluation ${row.id}`,
  },
  unit: {
    label: "Unit",
    apiPath: "units",
    searchField: "name_formatted",
    pathPrefix: "/units",
    pathMatcher: /^\/units\/(\d+)/,
    renderLabel: (row) => row.name_formatted || row.name || `Unit ${row.id}`,
  },
  permit: {
    label: "Permit",
    apiPath: "permits",
    searchField: "api_number",
    pathPrefix: "/permits",
    pathMatcher: /^\/permits\/(\d+)/,
    renderLabel: (row) => row.api_number || `Permit ${row.id}`,
  },
  deal_review: {
    label: "Deal Review",
    apiPath: "deal-reviews",
    searchField: "name",
    pathPrefix: "/deal-reviews",
    pathMatcher: /^\/deal-reviews\/(\d+)/,
    renderLabel: (row) => row.name || `Deal Review ${row.id}`,
  },
  title: {
    label: "Title",
    apiPath: "titles",
    searchField: "name",
    pathPrefix: "/titles",
    pathMatcher: /^\/titles\/(\d+)/,
    renderLabel: (row) => row.name || `Title ${row.id}`,
  },
  asset: {
    label: "Asset",
    apiPath: "assets",
    searchField: "name",
    pathPrefix: "/management/assets",
    pathMatcher: /^\/management\/assets\/(\d+)/,
    renderLabel: (row) => row.name || `Asset ${row.id}`,
  },
  tract: {
    label: "Tract",
    apiPath: "tracts",
    searchField: "name",
    pathPrefix: "/management/tracts",
    pathMatcher: /^\/management\/tracts\/(\d+)/,
    renderLabel: (row) => row.name || `Tract ${row.id}`,
  },
  deal: {
    label: "Deal",
    apiPath: "deals",
    searchField: "name",
    pathPrefix: "/management/deals",
    pathMatcher: /^\/management\/deals\/(\d+)/,
    renderLabel: (row) => row.name || `Deal ${row.id}`,
  },
  well: {
    label: "Well",
    apiPath: "wells",
    searchField: "api_uwi_10",
    pathPrefix: "/wells",
    pathMatcher: /^\/wells\/(\d+)/,
    renderLabel: (row) => row.name || row.api_uwi_10 || `Well ${row.id}`,
  },
  texas_tax_roll_file: {
    label: "Texas Tax Roll File",
    apiPath: null,
    searchField: null,
    pathPrefix: "/texas-tax-roll-files",
    pathMatcher: /^\/texas-tax-roll-files\/(\d+)/,
    renderLabel: (row) =>
      row.name || row.county || `Texas Tax Roll File ${row.id}`,
  },
  permit_plat: {
    label: "Permit Plat",
    apiPath: "permit-plats",
    searchField: "name",
    pathPrefix: "/permit-plats",
    pathMatcher: /^\/permit-plats\/(\d+)/,
    renderLabel: (row) => row.name || `Permit Plat ${row.id}`,
  },
  field_unit: {
    label: "Field Unit",
    apiPath: "field-units",
    searchField: "name",
    pathPrefix: "/field-units",
    pathMatcher: /^\/field-units\/(\d+)/,
    renderLabel: (row) => row.name || `Field Unit ${row.id}`,
  },
  offer: {
    label: "Offer",
    apiPath: "offers",
    searchField: "id",
    pathPrefix: "/offers",
    pathMatcher: /^\/offers\/(\d+)/,
    renderLabel: (row) => row.name || `Offer ${row.id}`,
  },
  paperwork: {
    label: "Paperwork",
    apiPath: null,
    searchField: null,
    pathPrefix: "/paperworks",
    pathMatcher: /^\/paperworks\/(\d+)/,
    renderLabel: (row) => row.filename_postfix || `Paperwork ${row.id}`,
  },
  unit_evaluation: {
    label: "Unit Evaluation",
    apiPath: null,
    searchField: null,
    pathPrefix: "/unit-evaluations",
    pathMatcher: /^\/unit-evaluations\/(\d+)/,
    renderLabel: (row) => row.name || `Unit Evaluation ${row.id}`,
  },
  mail_letter: {
    label: "Mail Letter",
    apiPath: null,
    searchField: null,
    pathPrefix: "/mail-letters",
    pathMatcher: /^\/mail-letters\/(\d+)/,
    renderLabel: (row) => row.name || `Mail Letter ${row.id}`,
  },
  mail_export: {
    label: "Mail Export",
    apiPath: "mail-exports",
    searchField: "name",
    pathPrefix: "/mail-exports",
    pathMatcher: /^\/mail-exports\/(\d+)/,
    renderLabel: (row) => row.name || `Mail Export ${row.id}`,
  },
  call: {
    label: "Call",
    apiPath: "calls",
    searchField: "to_number",
    pathPrefix: "/calls",
    pathMatcher: /^\/calls\/(\d+)/,
    renderLabel: (row) =>
      row.name || row.to_number || row.from_number || `Call ${row.id}`,
  },
  message: {
    label: "Message",
    apiPath: "messages",
    searchField: "id",
    buildPath: (record) =>
      record?.conversation_id
        ? `/conversations/${record.conversation_id}`
        : null,
    renderLabel: (row) => row.name || `Message ${row.id}`,
  },
  conversation: {
    label: "Conversation",
    apiPath: "conversations",
    searchField: "contact_address",
    pathPrefix: "/conversations",
    pathMatcher: /^\/conversations\/(\d+)/,
    renderLabel: (row) =>
      row.contact_address || row.name || `Conversation ${row.id}`,
  },
  operator_payor: {
    label: "Operator Payor",
    apiPath: "operator-payors",
    searchField: "name",
    pathPrefix: "/management/operator-payors",
    pathMatcher: /^\/management\/operator-payors\/(\d+)/,
    renderLabel: (row) => row.name || `Operator Payor ${row.id}`,
  },
  operator: {
    label: "Operator",
    apiPath: "operators",
    searchField: "name",
    pathPrefix: "/management/operators",
    pathMatcher: /^\/management\/operators\/(\d+)/,
    renderLabel: (row) => row.name || `Operator ${row.id}`,
  },
  royalty: {
    label: "Royalty",
    apiPath: "royalties",
    searchField: "id",
    pathPrefix: "/management/royalties",
    pathMatcher: /^\/management\/royalties\/(\d+)/,
    renderLabel: (row) => `Royalty ${row.id}`,
  },
  sale: {
    label: "Sale",
    apiPath: "sales",
    searchField: "id",
    pathPrefix: "/management/sales",
    pathMatcher: /^\/management\/sales\/(\d+)/,
    renderLabel: (row) => `Sale ${row.id}`,
  },
  taxing_entity: {
    label: "Taxing Entity",
    apiPath: "taxing-entities",
    searchField: "name",
    pathPrefix: "/management/taxing-entities",
    pathMatcher: /^\/management\/taxing-entities\/(\d+)/,
    renderLabel: (row) => row.name || `Taxing Entity ${row.id}`,
  },
  tax_statement: {
    label: "Tax Statement",
    apiPath: "tax-statements",
    searchField: "id",
    pathPrefix: "/management/tax-statements",
    pathMatcher: /^\/management\/tax-statements\/(\d+)/,
    renderLabel: (row) =>
      row.name ||
      `Tax Statement ${row.id}${row.tax_year ? ` (${row.tax_year})` : ""}`,
  },
  tax_appraisal: {
    label: "Tax Appraisal",
    apiPath: "tax-appraisals",
    searchField: "id",
    pathPrefix: "/management/tax-appraisals",
    pathMatcher: /^\/management\/tax-appraisals\/(\d+)/,
    renderLabel: (row) =>
      row.name ||
      `Tax Appraisal ${row.id}${row.tax_year ? ` (${row.tax_year})` : ""}`,
  },
  alert: {
    label: "Alert",
    apiPath: "alerts",
    searchField: "id",
    pathPrefix: "/management/alerts",
    pathMatcher: /^\/management\/alerts\/(\d+)/,
    renderLabel: (row) => `Alert ${row.id}`,
  },
  ticket: {
    label: "Ticket",
    apiPath: "tickets",
    searchField: "id",
    pathPrefix: "/management/tickets",
    pathMatcher: /^\/management\/tickets\/(\d+)/,
    renderLabel: (row) =>
      row.name || row.primary_ticket_record_name || `Ticket ${row.id}`,
  },
};

const OTHER_PATH_PREFIXES = {
  division_order: "/management/division-orders",
  entity: "/management/entities",
};

export const recordTypeOptions = Object.entries(RECORD_TYPES).map(
  ([value, cfg]) => ({ value, label: cfg.label })
);

export const recordPathFor = (recordType, recordId, record = null) => {
  if (!recordType || !recordId) return null;

  const cfg = RECORD_TYPES[recordType];
  if (!cfg) {
    const prefix = OTHER_PATH_PREFIXES[recordType];
    return prefix ? `${prefix}/${recordId}` : null;
  }

  if (cfg.buildPath) return cfg.buildPath(record);

  return cfg.pathPrefix ? `${cfg.pathPrefix}/${recordId}` : null;
};

export const recordSearchConfigFor = (recordType) => {
  const cfg = RECORD_TYPES[recordType];
  if (!cfg || !cfg.apiPath || !cfg.searchField) return null;

  return {
    apiPath: cfg.apiPath,
    searchField: cfg.searchField,
    renderLabel: cfg.renderLabel,
  };
};

export const detectRecordFromPath = (pathname) => {
  if (!pathname) return null;

  for (const [recordType, cfg] of Object.entries(RECORD_TYPES)) {
    if (!cfg.pathMatcher) continue;

    const match = pathname.match(cfg.pathMatcher);

    if (match) {
      return { record_type: recordType, record_id: Number(match[1]) };
    }
  }

  return null;
};
